import React from "react";
// import { shuffle } from "d3-array";
import { areas, prettyNames, colors } from "../../utils";
import {
  NeutralFaceDef,
  PositiveFaceDef,
  NegativeFaceDef
} from "../Bubbles/emoticons.js";

import "./keys.css";

const Keys = (props) => {
  if (!props.articles.length) {
    return null;
  }
  const {slugsSortedList} = props;
  // console.log(slugsSortedList);
  const firstArea = slugsSortedList[0][0];
  const secondArea = slugsSortedList[1][0];
  const selectedAreas = areas.filter(d => (d !== firstArea && d !== secondArea));

  return (<section className="keys parallax-layer parallax-layer-base">
    <div>
      <h3>
        Quali sono le news <span className="square-scale more">pi&ugrave;</span>{" "}
        o <span className="square-scale less">meno</span> popolari?
      </h3>
    </div>
    <div>
      <h3>
        Cosa scrivono i giornalisti di queste elezioni?<br/>E ne parlano in modo positivo{" "}
        <svg height="20" width="30">
          <g transform="scale(0.6) translate(0,9)">
            <PositiveFaceDef />
          </g>
        </svg>? Negativo{" "}
        <svg height="20" width="30">
          <g transform="scale(0.6) translate(0,10)">
            <NegativeFaceDef />
          </g>
        </svg>? O neutrale{" "}
        <svg height="20" width="30">
          <g transform="scale(0.6) translate(0,10)">
            <NeutralFaceDef />
          </g>
        </svg>?
      </h3>
    </div>
    <div>
      <h3>
        Si &egrave; scritto principalmente di <span className="party-name" style={{ borderColor: colors[firstArea] }}>{prettyNames[firstArea]}</span> e <span className="party-name" style={{ borderColor: colors[secondArea] }}>{prettyNames[secondArea]}</span>, ma cosa si scrive delle altre aree politiche? {selectedAreas.map((d,i) => (
          <span key={d}><span className="party-name" style={{ borderColor: colors[d] }}>{`${
      prettyNames[d]
      }`}</span>{i < selectedAreas.length - 2 ? ', ' : (i < selectedAreas.length - 1 ? ' e ' : '?')}</span>
        ))}
      </h3>
    </div>
  </section>)
}

export default Keys;



// WEBPACK FOOTER //
// ./src/elezioni/components/Layout/Keys.js